import * as React from 'react'
import { useEffect } from 'react'
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
} from 'antd'
import { useUserEditProfile } from './hooks'
import { submitEditUser, closeModal, $isSuccessCreate } from './model'
import { useUnit } from 'effector-react'
import { useNavigate } from 'react-router-dom'
import { path } from '../../../../libs'
import { $userGroups, groupsListMounted } from '../../groups/list/model'
import { UserMembershipBlock } from './membershipBlock'

type FormData = {
  username: string
  firstName: string
  lastName: string
  password?: string
  position: string
  email: string
  userGroups: string[]
}

export const UserEditProfile: React.FC = () => {
  const navigate = useNavigate()
  const { userEditProfile, loading } = useUserEditProfile()

  const [form] = Form.useForm<FormData>()

  const userGroups = useUnit($userGroups)
  const [isSuccessCreate, modalCloseFn] = useUnit([
    $isSuccessCreate,
    closeModal,
  ])

  useEffect(() => {
    groupsListMounted()
  }, [])

  useEffect(() => {
    form.setFieldsValue({
      username: userEditProfile.username || '',
      firstName: userEditProfile.firstName || '',
      lastName: userEditProfile.lastName || '',
      password: '',
      position: userEditProfile.position || '',
      email: userEditProfile.email || '',
      userGroups: userEditProfile.userGroups?.map((g) => g.id) || [],
    })
  }, [userEditProfile, form])

  useEffect(() => {
    if (isSuccessCreate) {
      navigate(path.users.details(String(userEditProfile.id)))
      modalCloseFn()
    }
  }, [isSuccessCreate])

  const onFinish = (values: FormData) => {
    submitEditUser({
      ...userEditProfile,
      ...values,
    } as any)
  }

  if (loading && !userEditProfile.id) {
    return (
      <div style={{ textAlign: 'center', padding: 24 }}>
        <Spin />
      </div>
    )
  }

  return (
    <Card
      title={
        <strong>
          Edit user {userEditProfile.id ? userEditProfile.id : ''}
        </strong>
      }
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ maxWidth: 520 }}
      >
        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: 'Username обязателен' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="First name"
          name="firstName"
          rules={[{ required: true, message: 'Имя обязательно' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Last name"
          name="lastName"
          rules={[{ required: true, message: 'Фамилия обязательна' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Password"
          name="password"
          rules={[
            {
              min: 8,
              message: 'Пароль должен содержать минимум 8 символов',
            },
          ]}
        >
          <Input.Password placeholder="Leave blank to keep current" />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: 'Email обязателен' },
            {
              pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: 'Введите корректный email адрес',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Position" name="position">
          <Input />
        </Form.Item>
        <Form.Item label="User groups" name="userGroups">
          <Select
            mode="multiple"
            allowClear
            options={userGroups.map((g) => ({ value: g.id, label: g.name }))}
            optionFilterProp="label"
          />
        </Form.Item>
        <Form.Item>
          <Row gutter={8}>
            <Col>
              <Button type="primary" htmlType="submit" loading={loading}>
                Save
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Card>
  )
}

export const UserEditDetail: React.FC = () => {
  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <UserEditProfile />
      <UserMembershipBlock />
    </Space>
  )
}
